import React, { useEffect, useState } from "react";
import Loader from "../../../components/loader/loader";
import Snackbar from "../../../components/snackbar/snackbar";
import { myInternshipDetail } from "../user.api";
import moment from "moment";
import { useHistory, useParams } from "react-router-dom";
import BreadCrumpBack from "../../../components/navigator/back";
import "./style.css";

export default function InternshipApplicationDetails(props) {
  const { id } = useParams();
  const history = useHistory();
  const [application, setApplication] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);

  useEffect(() => {
    if (id) {
      fetchDetails(id);
    }
  }, [id]);

  const fetchDetails = (appId) => {
    setIsLoading(true);
    myInternshipDetail(appId)
      .then((res) => {
        if (res?.success) {
          setApplication(res.data);
        } else {
          setSnackMessage("Failed to load application details");
          setIsSnackError(true);
          setSnackOpen(true);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching details:", error);
        setSnackMessage("Error loading application details");
        setIsSnackError(true);
        setSnackOpen(true);
        setIsLoading(false);
      });
  };

  const snackbarClose = () => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
  };

  if (isLoading) return <Loader open={isLoading} />;

  if (!application) return (
    <div className="container mt-5 text-center">
      <h4>No application details found</h4>
      <button className="btn btn-minimal-dark mt-3" onClick={() => history.push("/internship-applied")}>Back to List</button>
    </div>
  );

  const getBaseUrl = () => {
    const baseUrl = process?.env?.REACT_APP_BASE_URL || "http://127.0.0.1:8000/";
    return baseUrl.replace(/\/api\/?$/, "");
  };

  const resolvePath = (path) => {
    if (!path) return null;
    if (path.startsWith('http')) return path;
    const cleanBase = getBaseUrl().replace(/\/$/, "");
    const cleanPath = path.startsWith('/') ? path : `/${path}`;
    return `${cleanBase}${cleanPath}`;
  };

  const getStatusInfo = (status) => {
    const statusMap = {
      1: {
        label: props.state.language === "ma" ? "അംഗീകരിച്ചു" : "Approved",
        class: "successs",
        icon: (
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
        )
      },
      2: {
        label: props.state.language === "ma" ? "പുനഃപരിശോധനയിൽ" : "Reverted",
        class: "danger",
        icon: (
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <path d="M12 8v4m0 4h.01"></path>
          </svg>
        )
      },
      3: {
        label: props.state.language === "ma" ? "നിരസിച്ചു" : "Rejected",
        class: "danger",
        icon: (
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="15" y1="9" x2="9" y2="15"></line>
            <line x1="9" y1="9" x2="15" y2="15"></line>
          </svg>
        )
      },
    };
    const defaultIcon = (
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"></circle>
        <polyline points="12 6 12 12 16 14"></polyline>
      </svg>
    );
    return statusMap[status] || {
      label: props.state.language === "ma" ? "തീരുമാനമാകാത്തത്" : "Pending",
      class: "pending",
      icon: defaultIcon
    };
  };

  const statusInfo = getStatusInfo(application.status);

  return (
    <div className="registered-internships-page">
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />

      <div className="dash-banner">
        <div className="tit-txt">
          {props.state.language === "ma" ? "അപേക്ഷാ വിവരങ്ങൾ" : "Application Details"}
        </div>
      </div>

      <BreadCrumpBack />

      <div className="container-fluid mt-4 mb-5 px-md-5">
        {/* <div className="d-flex justify-content-end align-items-center mb-5"> */}
        {/* <h5 className="fw-bold text-dark mb-0">
            {props.state.language === "ma" ? "അപേക്ഷകന്റെ വിവരങ്ങൾ" : "Applicant Information"}
          </h5> */}
        {/* <button className="btn btn-minimal-outline btn-sm" onClick={() => history.push("/internship-applied")}>
            {props.state.language === "ma" ? "ലിസ്റ്റിലേക്ക് തിരികെ" : "Back to List"}
          </button> */}
        {/* </div> */}

        <div className="row g-4">
          {/* Left Column: Minimal Profile Sidebar */}
          <div className="col-lg-3 mb-4">
            <div className="section-card-minimal">
              <div className="section-header">
                {props.state.language === "ma" ? "സംഗ്രഹം" : "Summary"}
              </div>
              <div className="card-body p-4 text-center">
                <div className="mb-4">
                  {application.file_upload_photo ? (
                    <img
                      src={resolvePath(application.file_upload_photo)}
                      alt="Profile"
                      className="profile-img-minimal mx-auto"
                    />
                  ) : (
                    <div className="profile-img-minimal bg-light d-inline-flex align-items-center justify-content-center mx-auto">
                      <span className="h1 text-muted mb-0">{application.full_name?.charAt(0)}</span>
                    </div>
                  )}
                </div>
                <h5 className="fw-bold mb-1">{application.full_name}</h5>
                <p className="small text-muted mb-4 opacity-75">ID: {application.id}</p>

                <div className="text-start">
                  <div className="info-item-minimal mb-3 border-bottom pb-2">
                    <label>{props.state.language === "ma" ? "അപേക്ഷാ നില" : "Verification Status"}</label>
                    <span className={`status-badge-minimal ${statusInfo.class} d-inline-flex align-items-center mt-1`}>
                      <span className="me-1">{statusInfo.icon}</span>
                      {statusInfo.label}
                    </span>
                    {application.status === 3 && (
                      <div className="mt-2">
                        {application.admin_revert_message && (
                          <div className="mb-2 p-2 bg-danger-soft border border-danger rounded">
                            <label className="x-small text-danger fw-bold text-uppercase d-block mb-1" style={{ fontSize: '10px' }}>
                              {props.state.language === "ma" ? "നിരസിക്കാനുള്ള കാരണം" : "Rejection Reason"}
                            </label>
                            <p className="small mb-0 text-dark opacity-100 italic" style={{ fontSize: '12px' }}>"{application.admin_revert_message}"</p>
                          </div>
                        )}
                        <button
                          className="btn btn-minimal-outline btn-sm w-100 py-2 fw-bold"
                          style={{ borderStyle: 'dashed' }}
                          onClick={() => history.push(`/training-reg?id=${application.id}`)}
                        >
                          {props.state.language === "ma" ? "വിവരങ്ങൾ പുതുക്കുക" : "Update Information"}
                        </button>
                      </div>
                    )}
                  </div>
                  <div className="info-item-minimal mb-3 border-bottom pb-2">
                    <label>{props.state.language === "ma" ? "ഇമെയിൽ" : "Email Address"}</label>
                    <span className="text-break">{application.email}</span>
                  </div>
                  <div className="info-item-minimal mb-3 border-bottom pb-2">
                    <label>{props.state.language === "ma" ? "ഫോൺ" : "Contact Number"}</label>
                    <span>{application.phone_no}</span>
                  </div>
                  <div className="info-item-minimal mb-3">
                    <label>{props.state.language === "ma" ? "രജിസ്റ്റർ ചെയ്ത തീയതി" : "Registration Date"}</label>
                    <span>{moment(application.created_at).format("DD MMM YYYY")}</span>
                  </div>
                </div>

                {application.status === 2 && application.admin_revert_message && (
                  <div className="mt-4 p-3 bg-danger-soft border border-danger rounded text-start">
                    <label className="x-small text-danger fw-bold text-uppercase d-block mb-1">
                      {props.state.language === "ma" ? "പുനഃപരിശോധന നിർദ്ദേശം" : "Revert Message"}
                    </label>
                    <p className="small mb-0 text-dark opacity-100 italic">"{application.admin_revert_message}"</p>
                  </div>
                )}

                <div className="mt-4 pt-3 border-top">
                  {application.resume && (
                    <a href={resolvePath(application.resume)} target="_blank" rel="noreferrer" className="btn btn-minimal-dark w-100 shadow-sm mb-2">
                      {props.state.language === "ma" ? "റസ്യൂമി കാണുക" : "View Portfolio/Resume"}
                    </a>
                  )}
                  {application.rec_letter_name && (
                    <a href={resolvePath(application.rec_letter_name)} target="_blank" rel="noreferrer" className="btn btn-minimal-outline w-100 shadow-sm">
                      {props.state.language === "ma" ? "ശുപാർശ കത്ത് കാണുക" : "View Recommendation Letter"}
                    </a>
                  )}
                </div>
              </div>
            </div>

            {/* Institution Section */}
            <div className="section-card-minimal">
              <div className="section-header">
                {props.state.language === "ma" ? "സ്ഥാപനം" : "Institution"}
              </div>
              <div className="card-body p-4">
                {application.institution && application.institution.length > 0 ? (
                  application.institution.map((inst, idx) => (
                    <div key={idx} className="mb-3">
                      <div className="d-flex align-items-center gap-2 mb-3">
                        {inst.logo && (
                          <img src={resolvePath(inst.logo)} alt="Logo" style={{ width: '40px', height: '40px', objectFit: 'contain' }} className="rounded border" />
                        )}
                        <div className="fw-bold text-dark small">{inst.institution_name}</div>
                      </div>
                      <div className="info-item-minimal mb-2">
                        <label>{props.state.language === "ma" ? "റഫറൻസ് നമ്പർ" : "Ref No"}</label>
                        <span>{inst.unique_application_ref_no || "N/A"}</span>
                      </div>
                      {inst.address && (
                        <div className="info-item-minimal">
                          <label>{props.state.language === "ma" ? "വിലാസം" : "Address"}</label>
                          <span className="small">{inst.address}</span>
                        </div>
                      )}
                    </div>
                  ))
                ) : <div className="text-muted small italic">No institution details</div>}
              </div>
            </div>
          </div>

          {/* Right Column: Main Content Details */}
          <div className="col-lg-9">


            {/* Extended Details Grid */}
            <div className="section-card-minimal">
              <div className="section-header">
                {props.state.language === "ma" ? "വ്യക്തിഗത വിവരങ്ങൾ" : "Personal Information"}
              </div>
              <div className="info-grid-minimal">
                <div className="info-item-minimal">
                  <label>{props.state.language === "ma" ? "ലിംഗം" : "Gender"}</label>
                  <span>{application.gender || "Not specified"}</span>
                </div>
                <div className="info-item-minimal">
                  <label>{props.state.language === "ma" ? "ജനനത്തീയതി" : "Date of Birth"}</label>
                  <span>{moment(application.date_of_birth).format("DD MMM YYYY")}</span>
                </div>
                <div className="info-item-minimal">
                  <label>{props.state.language === "ma" ? "കേരളീയനാണോ?" : "Native of Kerala"}</label>
                  <span>{application.is_kerala_native ? "Yes" : "No"}</span>
                </div>
                <div className="info-item-minimal">
                  <label>{props.state.language === "ma" ? "അപേക്ഷാ രീതി" : "Course Track"}</label>
                  <span className="text-capitalize">{application.course_completion_status || "Standard"}</span>
                </div>
                {application.intern_languages && (
                  <div className="info-item-minimal col-span-2">
                    <label>{props.state.language === "ma" ? "ഭാഷകൾ" : "Languages Known"}</label>
                    <div className="d-flex gap-2 flex-wrap mt-1">
                      {application.intern_languages.map((l, i) => (
                        <span key={i} className="badge bg-light text-dark border px-2 py-1">{l.language}</span>
                      ))}
                    </div>
                  </div>
                )}
                <div className="info-item-minimal col-span-2">
                  <label>{props.state.language === "ma" ? "സ്ഥിരമായ വിലാസം" : "Permanent Address"}</label>
                  <span>{application.address}</span>
                </div>
              </div>
            </div>

            {/* Academic Section with Full Details */}
            <div className="section-card-minimal">
              <div className="section-header">
                {props.state.language === "ma" ? "യോഗ്യതകൾ" : "Academic Qualifications"}
              </div>
              <div className="card-body p-0">
                {application.intern_qualification && application.intern_qualification.map((q, idx) => (
                  <div key={idx} className={`p-4 ${idx > 0 ? 'border-top' : ''}`}>
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <div className="badge bg-dark-soft text-dark mb-2 text-uppercase font-8">{q.qualification_type?.name}</div>
                        <h6 className="fw-bold mb-0">{q.qualification?.name}</h6>
                        <div className="text-muted small mt-1">{q.stream?.name || "General"}</div>
                      </div>
                      <div className="col-md-4">
                        <div className="info-item-minimal mb-2">
                          <label>Board / University</label>
                          <span>{q.board}</span>
                        </div>
                        <div className="info-item-minimal">
                          <label>Year of Passing</label>
                          <span>{q.year_passed}</span>
                        </div>
                      </div>
                      <div className="col-md-2 text-end">
                        {q.certificate_photo && (
                          <a href={resolvePath(q.certificate_photo)} target="_blank" rel="noreferrer" className="btn btn-minimal-outline btn-sm">
                            {props.state.language === "ma" ? "സർട്ടിഫിക്കറ്റ്" : "View Proof"}
                          </a>
                        )}
                      </div>
                    </div>

                    {q.marks && q.marks.length > 0 && (
                      <div className="table-responsive border overflow-hidden mt-3">
                        <table className="table table-sm table-hover mb-0">
                          <thead className="bg-light">
                            <tr className="x-small text-uppercase">
                              <th className="px-3 py-2 border-0">Period</th>
                              <th className="py-2 border-0">Performance Detail</th>
                              <th className="py-2 border-0 text-center">Score</th>
                            </tr>
                          </thead>
                          <tbody>
                            {q.marks.map((m, mIdx) => (
                              <tr key={mIdx}>
                                <td className="px-3 py-2 fw-bold small">{m.period_label}</td>
                                <td className="py-2 small text-muted">
                                  {q.mark_system === 'semester_gpa' ? "GPA Tracking" : "Academic Marks"}
                                </td>
                                <td className="py-2 text-center fw-bold">
                                  {q.mark_system === 'semester_gpa' ? (
                                    <span className="text-primary">{m.cgpa || '--'}</span>
                                  ) : (
                                    <span>{m.marks_obtained} / {m.total_marks}</span>
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
            {/* Internships Applied Card Expansion */}
            {/* Internships Applied Card Expansion */}
            <div className="section-card-minimal">
              <div className="section-header">
                {props.state.language === "ma" ? "അപേക്ഷിച്ച ഇന്റേൺഷിപ്പുകൾ" : "Applied Internships & Preference Details"}
              </div>
              <div className="card-body p-0">
                {application.proposals && [...application.proposals].sort((a, b) => a.preference_order - b.preference_order).map((p, idx) => (
                  <div key={idx} className={`p-4 ${idx > 0 ? 'border-top' : ''}`}>
                    <div className="d-flex justify-content-between align-items-start mb-3">
                      <div>
                        <div className="d-flex align-items-center gap-2 mb-1">
                          <span className="badge rounded-circle bg-dark text-white d-inline-flex align-items-center justify-content-center" style={{ width: '24px', height: '24px', fontSize: '10px' }}>0{p.preference_order}</span>
                          <h6 className="fw-bold mb-0 text-primary">{p.internship_request?.internship_discipline}</h6>
                        </div>
                        <p className="text-secondary small mb-0 fw-bold">
                          <i className="bi bi-building me-1"></i> {p.internship_request?.company?.company_name}
                        </p>
                      </div>
                      <div className="text-end">
                        <span className={`badge ${p.status === 'pending' ? 'bg-warning-soft text-warning' : (p.status === 'rejected' || p.status === 'initially_rejected') ? 'bg-danger-soft text-danger' : 'bg-success-soft text-success'} py-2 px-3 mb-1 font-8`} style={{ borderRadius: '8px' }}>
                          {(p.status === 'initially_rejected') ? 'REJECTED' : p.status?.replace(/_/g, ' ')?.toUpperCase()}
                        </span>
                        <div className="text-dark-soft x-small fw-bold mt-1">
                          {props.state.language === "ma" ? "എന്റെ റാങ്ക്" : "My Rank"}: {p.admin_rank || "--"}
                        </div>
                      </div>
                    </div>

                    <div className="bg-light rounded-3 p-3 mt-3 border">
                      <div className="row g-3">
                        <div className="col-md-7">
                          <div className="mb-3 border-bottom pb-2">
                            <label className="x-small text-muted text-uppercase fw-bold d-block mb-1">
                              {props.state.language === "ma" ? "വിവരണം" : "Brief Description"}
                            </label>
                            <p className="small text-dark opacity-100 mb-0 line-height-1">
                              {p.internship_request?.brief_description || (props.state.language === "ma" ? "വിവരങ്ങൾ ലഭ്യമല്ല" : "No description provided.")}
                            </p>
                          </div>
                          <div>
                            <label className="x-small text-muted text-uppercase fw-bold d-block mb-1">
                              {props.state.language === "ma" ? "യോഗ്യതാ മാനദണ്ഡം" : "Criteria of Selection"}
                            </label>
                            <p className="small mb-0 text-dark-soft">
                              {p.internship_request?.grade_criteria || (props.state.language === "ma" ? "ബാധകമല്ല" : "None")}
                            </p>
                          </div>
                        </div>
                        <div className="col-md-5 border-start ps-md-4">
                          <div className="row g-3">
                            <div className="col-12">
                              <label className="x-small text-muted text-uppercase fw-bold d-block mb-1">
                                {props.state.language === "ma" ? "വിഭാഗം" : "Target Category"}
                              </label>
                              <div className="d-flex flex-wrap gap-2 mt-1">
                                {p.internship_request?.target_category === 'both' ? (
                                  <>
                                    <span className="badge-target-elite">
                                      {props.state.language === "ma" ? "കോഴ്സ് പൂർത്തിയാക്കിയ വിദ്യാർത്ഥികൾ" : "Students Completed Course"}
                                    </span>
                                    <span className="badge-target-elite">
                                      {props.state.language === "ma" ? "കോഴ്സ് പഠിച്ചുകൊണ്ടിരിക്കുന്ന വിദ്യാർത്ഥികൾ" : "Students Ongoing Course"}
                                    </span>
                                  </>
                                ) : (
                                  <span className="badge-target-elite">
                                    {props.state.language === "ma"
                                      ? (p.internship_request?.target_category === 'students_completed_course' ? "കോഴ്സ് പൂർത്തിയാക്കിയവർ" : "കോഴ്സ് പഠിച്ചുകൊണ്ടിരിക്കുന്നവർ")
                                      : p.internship_request?.target_category?.replace(/_/g, ' ')}
                                  </span>
                                )}
                              </div>
                            </div>
                            <div className="col-12 mt-2">
                              <label className="x-small text-muted text-uppercase fw-bold d-block mb-1">
                                {props.state.language === "ma" ? "കാലാവധി" : "Preferred Duration"}
                              </label>
                              <span className="small text-muted fw-bold">
                                {moment(p.internship_request?.preferred_start_date).format("DD MMM YYYY")} - {moment(p.internship_request?.preferred_end_date).format("DD MMM YYYY")}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}

                {(!application.proposals || application.proposals.length === 0) && (
                  <div className="p-5 text-center text-muted italic">
                    {props.state.language === "ma" ? "അപേക്ഷിച്ച ഇന്റേൺഷിപ്പുകൾ ലഭ്യമല്ല" : "No internship proposals found."}
                  </div>
                )}
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}

